var React = require('react');

function Consistent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"64/data"},[React.createElement("rect",{"width":"48","height":"48","rx":"8","fill":"#D0D4C2","key":0}),React.createElement("g",{"id":"Vector","key":1},[React.createElement("path",{"d":"M12 22.8889V34H17.4545V27.3333H21.8182V34H27.2727V22.8889L19.6364 17.3333L12 22.8889Z","fill":"#676D73","key":0}),React.createElement("path",{"d":"M21.8182 14V16.1889L29.4545 21.7444V22.8889H31.6364V25.1111H29.4545V27.3333H31.6364V29.5556H29.4545V34H36V14H21.8182ZM31.6364 20.6667H29.4545V18.4444H31.6364V20.6667Z","fill":"#676D73","key":1})])]));
}

Consistent.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Consistent;

Consistent.default = Consistent;
